import { Component, ViewEncapsulation, ViewChild, TemplateRef, Input, ElementRef } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { Router } from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { ExcelPdfComponent } from '../support/excel-pdf/excel-pdf.component';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
import { concatMap, from, of, tap } from 'rxjs';

export interface QmsQuestionnaireTempalteQuestionFieldInterface {
  qmsQuestionnaireTemplatesQuestionsVwPk: {
    questionId: Number;
  };
  createdBy: Number;
  updatedOn: Date;
  updatedBy: Number;
  createdByUser: String;
  updatedByUser: String;
  userId: Number;
  operation: String;
  deleteReason: String;
  templateId: Number;
  questionSeq: Number;
  question: String;
  fieldTypeCode: String;
  fieldValues: String;
}

export interface PopupData {
  title: String;
}
@Component({
  selector: 'app-qms-questionnaire-template-question',
  templateUrl: './qms-questionnaire-template-question.component.html',
  styleUrls: ['./qms-questionnaire-template-question.component.scss']
})
export class QmsQuestionnaireTemplateQuestionComponent {

  templateId: any;
  searchText: any;
  searchValue: any;
  isProcessing = true;
  _temp: any = {};
  columnLists: any = {};
  qmsQuestionnaireTemplateQuestionFieldDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  oddFieldType: any = null;

  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, private snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private elem: ElementRef) {
    const data: any = router.getCurrentNavigation()?.extras.state;
    this.message.breadcrumbData.fourthLevel = data.template.TEMPLATE_NAME;
  }

  ngOnDestroy() {
    this.message.breadcrumbData.fourthLevel = '';
  }

  backToPreviousPage() {
    this.router.navigate(['dashboard/qmsQuestionnaireTemplate'], {
      state: { fromQuestionTemplate: true }
    });
  }

  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;

  auditTrail: any = {};
  visibleAuditTrail: boolean = false;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pagedItems: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid
      .slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.qmsQuestionnaireTemplateQuestionFieldDataForGrid = [];
    const data = {

      gridName: "QUESTIONNAIRE_TEMPLATE_QUESTIONS"
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
    this.appService.getDynamicGridHeaders(data).subscribe((response: any) => {

      if (response.orderByClause == null) {
        response.orderByClause = "";
      }

      this.makeStickyColumns = response.fixedFieldCnt;

      const data1: any = {

        gridName: "QMS_QUESTIONNAIRE_TEMPLATE_QUESTIONS_VW",
        tableOrViewName: response.tableOrViewName == null ? "" : response.tableOrViewName,
        columnsList: response.columnsList == null ? "" : response.columnsList,
        fieldLabelsList: response.fieldLabelsList == null ? "" : response.fieldLabelsList,
        invisibleColumn: response.invisibleColumn == null ? "" : response.invisibleColumn,
        orderByClause: response.orderByClause == null ? "" : response.orderByClause,
        fieldSizeList: response.fieldSizeList == null ? "" : response.fieldSizeList,
        columnsListarray: [],
        fieldColumnarray: [],
        invisibleColumnarray: [],
        fieldSizeListArray: [],
        templateIdFromQmsQuestionnaireTemplate: !this.isCopyingTemplate ? this.message.templateIdFromQmsQuestionnaireTemplate : this.selectedSourceTemplate,
        manualEntryDataFields: response.manualEntryDataFields,
        clobColumnlist: response.closblist || "",
        blobColumnlist: response.bloblist || ""
      }
      this.reportObj = { ...data1, ...data };
      this.appService.getDynamicGridData(data1).subscribe((response1: any) => {
        this.qmsQuestionnaireTemplateQuestionFieldDataForGrid = response1;
        this.visibleAuditTrail = false;
        data1.columnsListarray = data1.columnsList.split(",");
        data1.fieldColumnarray = data1.fieldLabelsList.split(",");
        data1.invisibleColumnarray = data1.invisibleColumn.split(",");
        data1.fieldSizeListArray = data1.fieldSizeList.split(",");
        let rendereddata: any;
        this.columnLists.columnsListarray = data1.columnsListarray;
        this.columnLists.fieldLabelsList = data1.fieldLabelsList;
        this.columnLists.fieldColumnarray = [];
        for (let p = 0; p < data1.fieldColumnarray.length; p++) {
          this.columnLists.fieldColumnarray.push({
            "fieldColumnarray": data1.fieldColumnarray[p],
            "width": data1.fieldSizeListArray[p] + 'px'
          })
        }
        this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
        this.columnLists.fieldSizeListArray = [];
        for (let w = 0; w < data1.fieldSizeListArray.length; w++) {
          this.columnLists.fieldSizeListArray.push(data1.fieldSizeListArray[w] + 'px');
        }
        for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
          for (let k = 0; k < this.columnLists.invisibleColumnarray.length; k++) {
            if (this.columnLists.columnsListarray[y] == this.columnLists.invisibleColumnarray[k]) {
              this.columnLists.columnsListarray.splice(y, 1);
              this.columnLists.fieldColumnarray.splice(y, 1);
              this.columnLists.fieldSizeListArray.splice(y, 1);
            }
          }
        }

        let tableData = {
          tablename: data1.tableOrViewName
        };
        this.columnLists.columnsListarray1 = [];
        this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
          this.dataTypeList = response2;
          for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
            this.columnLists.columnsListarray1.push({});
            this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
            this.columnLists.columnsListarray1[m].dataType = "textbox";
            this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
            for (let w = 0; w < this.dataTypeList.length; w++) {
              if (this.dataTypeList[w].columnName == this.columnLists.columnsListarray[m]) {
                this.columnLists.columnsListarray1[m].dataType = this.dataTypeList[w].fieldType;
              }
            }
          }
          for (let i = 0; i < this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length; i++) {
            for (let y = 0; y < this.dataTypeList.length; y++) {
              if (this.dataTypeList[y].fieldType == 'CHECKBOX') {
                this.qmsQuestionnaireTemplateQuestionFieldDataForGrid[i][this.dataTypeList[y].columnName] = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid[i][this.dataTypeList[y].columnName] == "Y" ? true : false;
              }
            }
          }
          this.calculateTotalPages = this.collectionSize / this.perPage;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        });
        this.message.gridList = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid;
        this.collectionSize = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length;
        this.totalPages = Math.ceil(this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length / this.itemsPerPage);
        this.dynamicLabelCall();
      }, (error) => {
        this.isProcessing = false;
        throw error;
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssFunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            let previousColumn = elements1[key - 1];
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = key % 2 == 0 ? 'white' : 'white';
          // column.style.textDecoration = "underline";
          // column.style.color = "blue";
          // column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length; p++) {
        this.qmsQuestionnaireTemplateQuestionFieldDataForGrid[p].childCheckBoxs = true;
      }
    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.length; p++) {
        this.qmsQuestionnaireTemplateQuestionFieldDataForGrid[p].childCheckBoxs = false;
      }
    }
  }

  previousIdx: any;
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      if (this.previousIdx != undefined) {
        this.qmsQuestionnaireTemplateQuestionFieldDataForGrid[this.previousIdx].childCheckBoxs = false;
      }
      list.childCheckBoxs = true;
      this.auditTrail.refNo = list.QUESTION_ID;
    } else {
      list.childCheckBoxs = false;
    }
    this.visibleAuditTrail = this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.some((list: any) => list.childCheckBoxs);
    this.previousIdx = idx;
  }

  onParentChecked(e: any) {
    if (e.target.checked) {
      if (this.isCopyingTemplate) { this.copyingQuestionsData = this.pagedItems.length == 10 ? this.qmsQuestionnaireTemplateQuestionFieldDataForGrid : this.pagedItems; }
      for (const element of this.qmsQuestionnaireTemplateQuestionFieldDataForGrid) {
        element.childCheckBox = true;
      }
    } else {
      if (this.isCopyingTemplate) { this.copyingQuestionsData = [] }
      for (const element of this.qmsQuestionnaireTemplateQuestionFieldDataForGrid) {
        element.childCheckBox = false;
      }
    }
  }

  onChildChanged(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBox = true;
      this.onChildChecked(list);
    } else {
      this.parentCheckBox = list.childCheckBox = false;
      this.isCopyingTemplate && this.onChildUnchecked(list);
    }
  }

  onChildChecked(checked: any) {
    if (!this.isCopyingTemplate) {
      this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.every((item: any) => { if (item.childCheckBox && item.QUESTION_ID != checked.QUESTION_ID) { item.childCheckBox = false; } return true; })
    } else {
      if (!this.copyingQuestionsData?.some((copied: any) => copied.QUESTION_ID === checked.QUESTION_ID)) {
        this.copyingQuestionsData.push(checked);
      }

      if (this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.every((r: any) => r.childCheckBox)) {
        this.parentCheckBox = true;
      }
    }
  }

  onChildUnchecked(unchecked: any) {
    const removal = this.copyingQuestionsData?.findIndex((copied: any) => copied.QUESTION_ID == unchecked.QUESTION_ID);
    if (removal > -1) this.copyingQuestionsData?.splice(removal, 1);
  }


  dropDownDataForFieldType: any = [];
  ngOnInit() {
    this.qmsQuestionnaireQuestionsFieldData.updateReason = '';
    this.getcallMethod();
    this.templateId = this.message.templateIdFromQmsReportTemplate;
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("FIELD_TYPE").subscribe((data: any) => {
      this.dropDownDataForFieldType = data;
      this.selectBoxForFieldType();
      this.isProcessing = false;
    })
  }

  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  selectedFieldType: any = null;
  fieldTypeListDropdown: any = [];

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  fieldTypesearchTxt: any;
  selectBoxForFieldType() {
    this.fieldTypeListDropdown = [];
    for (let i = 0; i < this.dropDownDataForFieldType.length; i++) {
      this.fieldTypeListDropdown = this.fieldTypeListDropdown.concat({
        valueExp: this.dropDownDataForFieldType[i].codelistCode,
        displayExp: this.dropDownDataForFieldType[i].codelistName
      });
    }
    //this code temp hide
    this.fieldTypeListDropdown = this.fieldTypeListDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Heading'));

  }

  qmsQuestionnaireQuestionsFieldData: any = {};
  operationFlag: any;
  popupDataTitle: PopupData = {
    title: ''
  };

  popupTitle: string | null = 'title';
  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;

  addAndEditPopupConfig = {
    width: '50%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  getWidth() {
    return this.isCopyingTemplate ? '75%' : '50%';
  }

  dynamicWidth() {
    const newWidth = this.getWidth();
    if (this.visibleAddAndEditPopup) {
      this.visibleAddAndEditPopup.updateSize(newWidth);
    }
  }


  deletePopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  visibleAddButton: boolean;
  visibleEditButton: boolean;

  openAddPopup() {
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.operationFlag = 'ADD';
    this.popupDataTitle.title = "Create QMS Questionnaire Template Question";
    this.selectedUserCriteria = 'Create New';
    this.selectedFieldType = null;
    this.qmsQuestionnaireQuestionsFieldData.question = '';
    this.qmsQuestionnaireQuestionsFieldData.fieldValues = '';
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  previousData: any;
  previousDataQuestionId: any;
  previousDatatemplateId: any;
  getQmsQuestionnaireQuestionDetails: any = [];
  filteredFieldTypeValue: any = [];
  openEditPopup(qmsQuestionnaireQuestionRowData: any) {
    this.isProcessing = true;
    console.log(qmsQuestionnaireQuestionRowData);
    this.previousData = qmsQuestionnaireQuestionRowData;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.operationFlag = 'EDIT';
    this.popupDataTitle.title = "Update QMS Questionnaire Template Question";
    this.selectedUserCriteria = 'Update';
    this.previousDatatemplateId = qmsQuestionnaireQuestionRowData.TEMPLATE_ID;
    this.previousDataQuestionId = qmsQuestionnaireQuestionRowData.QUESTION_ID;
    this.appService.getQmsQuestionnaireTemplateQuestionDetailsByOrgIdAndTemplateIdAndQuestionId(this.previousDatatemplateId, this.previousDataQuestionId).subscribe((response: any) => {
      this.getQmsQuestionnaireQuestionDetails = response
      this.qmsQuestionnaireQuestionsFieldData.templateId = this.getQmsQuestionnaireQuestionDetails.templateId;
      this.qmsQuestionnaireQuestionsFieldData.questionSeq = this.getQmsQuestionnaireQuestionDetails.questionSeq;
      this.qmsQuestionnaireQuestionsFieldData.question = this.getQmsQuestionnaireQuestionDetails.question;
      this.qmsQuestionnaireQuestionsFieldData.fieldValues = this.getQmsQuestionnaireQuestionDetails.fieldValues;
      this.qmsQuestionnaireQuestionsFieldData.updateReason = '';
      if (this.getQmsQuestionnaireQuestionDetails.fieldTypeCode) {
        const matchingFieldType = this.dropDownDataForFieldType?.find((item: any) => item.codelistCode == this.getQmsQuestionnaireQuestionDetails.fieldTypeCode);
        if (!matchingFieldType) {
          this.oddFieldType = this.getQmsQuestionnaireQuestionDetails.fieldTypeCode;
          this.fieldTypeListDropdown.push({
            valueExp: this.getQmsQuestionnaireQuestionDetails.fieldTypeCode,
            displayExp: this.getQmsQuestionnaireQuestionDetails.fieldTypeCode
          })
        }
        //this code temp hide
        this.fieldTypeListDropdown = this.fieldTypeListDropdown.filter((item: { displayExp: string; }) => (item.displayExp !== 'Heading'));
        this.selectedFieldType = this.getQmsQuestionnaireQuestionDetails.fieldTypeCode;
      }
      this.isProcessing = false;
      this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
    })
  }

  questionValue: any;
  fieldTypeValue: any;

  questionRequiredMsg: any;
  fieldTypeRequiredMsg: any;
  updateReq: any;
  updateReqMsg: any;


  fieldValidation() {
    this.questionValue = document.getElementById('question') as HTMLInputElement;
    this.fieldTypeValue = document.getElementById('fieldType') as HTMLInputElement;

    this.questionRequiredMsg = document.getElementById('question-required-msg') as HTMLInputElement;
    this.fieldTypeRequiredMsg = document.getElementById('fieldType-required-msg') as HTMLInputElement;

    this.updateReq = document.getElementById('update-validation') as HTMLInputElement;
    this.updateReqMsg = document.getElementById('update-required-msg') as HTMLInputElement;

    if (this.questionValue.value == "") {
      this.questionValue.style.border = '1px solid red';
      this.questionRequiredMsg.style.display = 'block';
    } else {
      this.questionValue.style.border = 'none';
      this.questionRequiredMsg.style.display = 'none';
    }
    if (this.visibleEditButton) {
      if (!this.updateReq.value) {
        this.updateReq.style.border = '1px solid red';
        this.updateReqMsg.style.display = 'block';
      } else {
        this.updateReq.style.border = 'none';
        this.updateReqMsg.style.display = 'none';
      }
    }
    if (!this.selectedFieldType) {
      this.fieldTypeValue.style.border = '1px solid red';
      this.fieldTypeRequiredMsg.style.display = 'block';
    } else {
      this.fieldTypeValue.style.border = 'none';
      this.fieldTypeRequiredMsg.style.display = 'none';
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  isUpdateReasonEmpty: boolean;
  addAndEditFunction(qmsQuestionnaireQuestionsFieldData: any) {
    console.log("Catch");
    this.isProcessing = true;
    //  Single validation for both fields
    const isFieldTypeEmpty = !this.selectedFieldType || (Array.isArray(this.selectedFieldType) && this.selectedFieldType.length === 0);
    const isQuestionEmpty = !this.qmsQuestionnaireQuestionsFieldData.question || this.qmsQuestionnaireQuestionsFieldData.question.trim() === '';
    const isUpdateReasonEmpty = this.visibleEditButton && !this.qmsQuestionnaireQuestionsFieldData.updateReason;
    if (isFieldTypeEmpty || isQuestionEmpty || isUpdateReasonEmpty) {
      this.isProcessing = false;

      // Build error message based on what's missing
      let errorMessage = "Please ";
      const missingFields = [];

      if (isQuestionEmpty) {
        missingFields.push("enter the Question");
      }
      if (isFieldTypeEmpty) {
        missingFields.push("select the Field Type Code");
      }
      if (isUpdateReasonEmpty) {
        missingFields.push("enter update reason");
      }

      // Join with "and" if both are missing
      errorMessage += missingFields.join(" and ") + ".";

      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: errorMessage,
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      return;
    }

    if (this.operationFlag == 'ADD') {
      qmsQuestionnaireQuestionsFieldData.templateId = this.message.templateIdFromQmsQuestionnaireTemplate;
      qmsQuestionnaireQuestionsFieldData.question = this.qmsQuestionnaireQuestionsFieldData.question;
      qmsQuestionnaireQuestionsFieldData.fieldValues = this.qmsQuestionnaireQuestionsFieldData.fieldValues;
      qmsQuestionnaireQuestionsFieldData.fieldTypeCode = this.selectedFieldType;
      this.appService.createQmsQuestionnaireTemplateQuestion(this.qmsQuestionnaireQuestionsFieldData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleAddAndEditPopup.close();
          this.getcallMethod();
        }
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: this.displayResultType == 'S' ? 5000 : undefined,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    } else {

      delete qmsQuestionnaireQuestionsFieldData.createdOn;
      delete qmsQuestionnaireQuestionsFieldData.updatedOn;
      qmsQuestionnaireQuestionsFieldData.qmsQuestionnaireTemplatesQuestionsVwPk = {
        questionId: this.previousDataQuestionId,
      }
      qmsQuestionnaireQuestionsFieldData.templateId = this.message.templateIdFromQmsQuestionnaireTemplate;
      qmsQuestionnaireQuestionsFieldData.question = this.qmsQuestionnaireQuestionsFieldData.question;
      qmsQuestionnaireQuestionsFieldData.fieldValues = this.qmsQuestionnaireQuestionsFieldData.fieldValues;
      qmsQuestionnaireQuestionsFieldData.fieldTypeCode = this.selectedFieldType;
      this.appService.updateQmsQuestionnaireTemplateQuestion(this.qmsQuestionnaireQuestionsFieldData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleAddAndEditPopup.close();
          this.getcallMethod();
        }
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: this.displayResultType == 'S' ? 5000 : undefined,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok",
            pageName: this.message.breadcrumbData.thirdLevel == null ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  cancelAddAndEditFunction() {
    if (this.isCopyingTemplate) { this.isCopyingTemplate = false; }
    this.getcallMethod();
    this.visibleAddAndEditPopup.close();
  }

  deleteQmsQuestionnaireTemplateQuestionId: any;
  openDeletePopup(deleteRowData: any) {
    console.log(deleteRowData);
    this.operationFlag = 'DELETE';
    this.popupDataTitle.title = "Delete QMS Questionnaire Template Question";
    this.deleteQmsQuestionnaireTemplateQuestionId = deleteRowData.QUESTION_ID;
    this.qmsQuestionnaireQuestionsFieldData.deleteReason = '';
    this.visibleDeletePopup = this.dialog.open(this.deletePopup, this.deletePopupConfig);
  }

  deleteFieldValue: any;

  deleteFieldValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFieldValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    this.deleteFieldValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;

    if (this.deleteFieldValue.value == '') {
      this.isProcessing = false;
      this.deleteFieldValue.style.border = '1px solid red';
      this.deleteFieldValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFieldValue.style.border = 'none';
      this.deleteFieldValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction(qmsQuestionnaireQuestionsFieldData: any) {
    this.isProcessing = true;
    if (this.qmsQuestionnaireQuestionsFieldData.deleteReason == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      qmsQuestionnaireQuestionsFieldData.qmsQuestionnaireTemplatesQuestionsVwPk = {
        questionId: this.deleteQmsQuestionnaireTemplateQuestionId,
      }
      qmsQuestionnaireQuestionsFieldData.templateId = this.message.templateIdFromQmsQuestionnaireTemplate;
      qmsQuestionnaireQuestionsFieldData.deleteReason = this.qmsQuestionnaireQuestionsFieldData.deleteReason;
      this.appService.deleteQmsQuestionnaireTemplateQuestion(qmsQuestionnaireQuestionsFieldData).subscribe((Response: any) => {
        this.displayMessage = Response.result;
        this.displayResultType = Response.resultType;
        if (this.displayResultType == 'S') {
          this.visibleDeletePopup.close();
          this.getcallMethod();
        }
        this.isProcessing = false;
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: this.displayResultType == 'S' ? 5000 : undefined,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }

  sortedColumn: string = '';
  sortDirection: string = 'asc';
  sortColumn(column: string, list: any) {
    if (column === this.sortedColumn) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortedColumn = column;
      this.sortDirection = 'asc';
    }
    list.showsort = this.sortDirection;

    this.qmsQuestionnaireTemplateQuestionFieldDataForGrid.sort((a: { [x: string]: any; }, b: { [x: string]: any; }) => {
      const key = column as string;
      const valueA = a[key];
      const valueB = b[key];

      if (valueA! < valueB!) {
        return this.sortDirection === 'asc' ? -1 : 1;
      } else if (valueA! > valueB!) {
        return this.sortDirection === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    });
    this.setPage(1, 0);
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;

  openAuditTrail(viewType: any, questionnaire: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : questionnaire.QUESTION_ID;
    this.auditTrail.templateIdFromQmsQuestionnaireTemplate = this.message.templateIdFromQmsQuestionnaireTemplate;
    this.auditTrail.gridName = 'QUESTIONNAIRE_TEMPLATE_QUESTIONS';
    this.auditTrail.report_And_Popup_Name = 'Questionnaire Template Questions Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(questionnaire);
  }


  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};
  reportObj: any = {};

  openReport(reportType: string) {
    this.excelPdf.reportObj = this.reportObj;
    this.excelPdf.reportType = 'Dynamic';
    this.excelPdf.reportName = 'QMS Questionnaire Template Questions Report';
    this.excelPdf.dropDown = this.columnLists?.fieldColumnarray?.map((item: any) => item.fieldColumnarray);
    this.excelPdfComponent.openReportPopup(reportType);
  }

  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall(this.reportObj.gridName, this.reportObj.tableOrViewName, null, 0)
  }

  onChildValueEmitted() {
    this.getcallMethod();
  }

  dynamicLabel: any = null;
  label: any = [];
  dynamicLabelCall() {
    this.isProcessing = true;
    const data = {
      tableName: this.reportObj.tableOrViewName,
      moduleName: null,
      gridName: this.reportObj.gridName,
      groupId: 0,
    };
    this.appService.getreorderGirdColumnList(data).subscribe((data: any) => {
      this.label = data;
      this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
        acc[`${user.columnName}`] = user.changedFieldName;
        return acc;
      }, {});
      this.isProcessing = false;
    }, (error: any) => {
      this.isProcessing = false;
    });
  }

  selectedUserCriteria: any;
  searchCriteriaOptions: any = ['Create New', 'Copy'];
  copyingQuestionsData: any = [];

  @ViewChild('copyResultPopup', { static: true }) copyResultPopup: TemplateRef<any>;
  visibleCopyResultPopup: MatDialogRef<TemplateRef<any>>;

  copyResultPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  onSearchCriteriaChanged(criteria: any) {
    if (criteria == 'Create New') {
      this.selectedFieldType = null;
      this.qmsQuestionnaireQuestionsFieldData.question = '';
      this.qmsQuestionnaireQuestionsFieldData.fieldValues = '';
      this.isCopyingTemplate = false;
    } else {
      [
        this.pagedItems,
        this.qmsQuestionnaireTemplateQuestionFieldDataForGrid,
        this.copyingQuestionsData,
        this.responses,
        this.selectedSourceTemplate,
        this.selectedTargetTemplate,
        this.parentCheckBox,
        this.isCopyingTemplate
      ] = [[], [], [], [], null, null, false, true];

      this.isProcessing = true;
      this.appService.getQuestionnaireTemplateByOrgIdAndUserId().subscribe((response: any) => {
        this.dropdownForTemplate = response;
        this.selectBoxForTemplate();
        this.isProcessing = false;
      })
    };

    setTimeout(() => this.dynamicWidth());
  }

  selectedSourceTemplate: any;
  selectedTargetTemplate: any;

  templateDropdown: any = [];
  dropdownForTemplate: any = [];

  templateSearchText: string = '';
  isCopyingTemplate: boolean = false;

  selectBoxForTemplate() {
    this.templateDropdown = this.dropdownForTemplate?.map((template: any) => ({
      valueExp: template.qmsQuestionnaireTemplatesVwPk.templateId,
      displayExp: template.templateName
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m?.displayExp?.trim()?.localeCompare(n?.displayExp?.trim())) || []
  }

  onSourceModuleSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.getcallMethod();
      } else {
        this.pagedItems = [];
        this.isProcessing = false;
      }
    }
  }

  responses: any[] = []; /* To store the responses sequentially */

  copy() {


    this.isProcessing = true;

    //  Check all validations at once
    const isSourceTemplateEmpty = !this.selectedSourceTemplate;
    const isTargetTemplateEmpty = !this.selectedTargetTemplate;
    const isQuestionsEmpty = !this.copyingQuestionsData || this.copyingQuestionsData.length === 0;

    // Build error message based on what's missing
    if (isSourceTemplateEmpty || isTargetTemplateEmpty || isQuestionsEmpty) {
      this.isProcessing = false;

      let errorMessage = "Please ";
      const missingFields = [];

      // Check templates first (can be combined)
      if (isSourceTemplateEmpty && isTargetTemplateEmpty) {
        missingFields.push("select the Source Template and Target Template");
      } else if (isSourceTemplateEmpty) {
        missingFields.push("select the Source Template");
      } else if (isTargetTemplateEmpty) {
        missingFields.push("select the Target Template");
      }

      // Check questions (standalone)
      if (isQuestionsEmpty) {
        missingFields.push("select questions to copy");
      }

      // Join with appropriate connectors
      if (missingFields.length === 1) {
        errorMessage += missingFields[0] + ".";
      } else {
        errorMessage += missingFields.slice(0, -1).join(", ") + " and " + missingFields[missingFields.length - 1] + ".";
      }

      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: errorMessage,
          type: 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      return;
    }
    from(this.copyingQuestionsData) /* 'from' converts the array into an observable stream */
      .pipe(
        concatMap((question: any, index: number) => { /* 'concatMap' ensures that the next API call does not start until the current one is complete */
          const obj = {
            templateId: this.selectedTargetTemplate,
            question: question.QUESTION,
            fieldValues: question.FIELD_VALUES,
            fieldTypeCode: question.FIELD_TYPE_CODE,
          }

          /*  Call the API for the current setting */
          return this.appService.createQmsQuestionnaireTemplateQuestion(obj).pipe(
            tap((Response: any) => { /* 'tap' is an operator used to perform side effects for debugging or performing actions without altering the data flowing through the observable stream */
              /* Store the response after the API call */
              this.responses[index] = { question, response: Response, };
            }),
            /* Ensure the observable emits a value for next() */
            concatMap(() => of(question))
            /* 'of(setting)' creates an observable that emits the current setting after the API call is complete.
               This observable is processed by the from pipeline and triggers the next handler for every iteration */
          );
        })
      )
      .subscribe({
        next: (item) => {
          console.log('Processed an item:', item); /* Logs the processed item where this next is triggered by of(setting) */
        },
        complete: () => {
          console.log('All API calls have been processed');
          console.log('Responses:', this.responses); /* Log the final responses array */
          this.isProcessing = false;
          this.visibleAddAndEditPopup.close();
          this.visibleCopyResultPopup = this.dialog.open(this.copyResultPopup, this.copyResultPopupConfig);
        },
        error: (error) => {
          this.isProcessing = false;
          console.error('Error occurred:', error);
        },
      });
  }

  cancelCopyResultPopup() {
    this.isCopyingTemplate = false;
    this.getcallMethod();
    this.visibleCopyResultPopup.close();
  }


}
